module.exports = __webpack_public_path__ + "assets/img/free_31.ce662167.png";